import { render, staticRenderFns } from "./TabbedGraphTopViewText.vue?vue&type=template&id=14b91b86&scoped=true&"
import script from "./TabbedGraphTopViewText.vue?vue&type=script&lang=js&"
export * from "./TabbedGraphTopViewText.vue?vue&type=script&lang=js&"
import style0 from "./TabbedGraphTopViewText.vue?vue&type=style&index=0&id=14b91b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b91b86",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b91b86')) {
      api.createRecord('14b91b86', component.options)
    } else {
      api.reload('14b91b86', component.options)
    }
    module.hot.accept("./TabbedGraphTopViewText.vue?vue&type=template&id=14b91b86&scoped=true&", function () {
      api.rerender('14b91b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/results-pages/tabs/TabbedGraphTopViewText.vue"
export default component.exports